import * as yup from "yup";

export const validationSchema = yup.object().shape({
  crane_type_id: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string().required(),
        value: yup.mixed().required(),
      })
    )
    .min(1, "Selecciona al menos una categoría de grúa")
    .required("Campo requerido"),
  crane_number: yup
    .number()
    .typeError("El número de grua debe ser un número")
    .required("Ingrese el número de Grúa"),
  plate: yup.string().required("Ingrese la placa de la grúa"),
  insurance_id: yup.number().required("Seleccione la aseguradora"),
  civil_liability_policy: yup.string().required("Ingrese el número de póliza"),
  // vehicular_config: yup
  //   .mixed()
  //   .test(
  //     "is-selected",
  //     "Seleccione una configuración vehicular",
  //     (value) => value !== null && typeof value === "object" && !!value.id
  //   )
  //   .required("Seleccione una configuración vehicular"),
  serial_number: yup.string().required("Ingrese el número de serie"),
  gross_vehicle_weight: yup
    .number()
    .typeError("El peso bruto de grua debe ser un número")
    .required("Ingrese el peso bruto vehicular"),
  description: yup.string().required("Ingrese una descripción"),
  year: yup
    .number()
    .typeError("El año debe ser un número")
    .required("Ingrese el año"),
  capacity: yup
    .number()
    .typeError("La capacidad debe ser un número")
    .required("Ingrese la capacidad"),
  // sct_permit: yup
  //   .mixed()
  //   .test(
  //     "is-selected",
  //     "Seleccione el permiso SCT",
  //     (value) => value !== null && typeof value === "object" && !!value.id
  //   )
  //   .required("Seleccione el permiso SCT"),
  sct_permit_number: yup.string().required("Ingrese el número de permiso SCT"),
});

export const initialValues = {
  crane_type_id: [],
  crane_number: "",
  plate: "",
  description: "",
  year: "",
  capacity: "",
  serial_number: "",
  vehicular_config: "",
  gross_vehicle_weight: "",
  insurance_id: "",
  civil_liability_policy: "",
  sct_permit: "",
  sct_permit_number: "",
};